import {PlotInfoFragment} from "generated/graphql";

export const getAvailableEmasculations = (plot: PlotInfoFragment) =>
  Math.min(
    plot.counts.toEmasculate,
    plot.crossingsMother.reduce((a,b) => (b.father?.available ?? 0) + a, 0)
  );